import { Header } from "/react4xp/parts/header/header";

export default (props) => <Header {...props} />